export const CHANGE_CATEGORY = "songs/CHANGE_CATEGORY";
export const CHANGE_CURRENT_CATEGORY = "songs/CHANGE_CURRENT_CATEGORY";
export const CHANGE_CATEGORY_SONGS = "songs/CHANGE_CATEGORY_SONGS";

export const PER_PAGE_NUMBER = 35;
